import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5 11L5 13L15.5 13L10.5 18.5L12.8806 18.5L19 11.9906L12.8806 5.5L10.5 5.5L15.5 11L5 11Z"
        fill="var(--svg-color-main, black)"
      />
    </svg>
  )
}
